import { Link, List } from '@farol-ds/react'
import { useMetrics } from '@jusbrasil-web/docview/core'
import { buildCanonicalSERPUrl } from '@jusbrasil-web/shared-search-canonical-url'

import styles from './subject-item.module.scss'

export type SubjectItemProps = {
  subject?: string | null
}

export function SubjectItem(props: SubjectItemProps) {
  const { subject } = props
  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLLIElement>()

  const handleClick = () => {
    sendMetrics('Peca.LawsuitSubjectsClicked')
  }

  const motionSerpUrl = buildCanonicalSERPUrl({
    path: '/pecas/busca',
    queryParams: { q: subject as string },
  })

  return (
    <List.Item className={styles.item} ref={dispatcherRef}>
      <Link type="ghost" href={motionSerpUrl} onClick={handleClick}>
        {subject}
      </Link>
    </List.Item>
  )
}
